import { post } from '@/common/request/index';

const OPTIONS = { isMock: false, mockId: 0, mockSuffix: '/api', needHint: true };

export function chooseTenant(params: { tenantId: string | number }) {
  return post('/chooseTenant', params, OPTIONS);
}
